const RoleTypes = {
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN: "ADMIN",
  MEMBRE: "MEMBRE",
  USER: "USER",
};

export { RoleTypes };
